import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class Search implements ng.IController {
    public text: string;
    public onClearClick: () => any;

    public clear() {
        this.text = '';
        this.onClearClick();
    }
}

angular.module('naut').component('search', {
    template: require('./search.component.html'),
    controller: Search,
    controllerAs: 'ctrl',
    bindings: {
        placeholderText: '<',
        disabled: '<',
        text: '<',
        classes: '<',
        onSearchClick: '&',
        onClearClick: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/shared/search/search.component.ts